import React from 'react'
import './AdminHeader.css'
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';



export default function AdminHeader({pageName}) {
  return (
    <div className='adminHeader-container'>
      <Link to='/admin'><img className='adminHeader-logo' src="./images/logo.png" alt="" /></Link>
      <h1 className='adminheader-pagename'>{pageName}</h1>
      <Link to='/' className='adminheader-link'><LogoutIcon/></Link> 
    </div>
  )
}
